import { EventTicketStatus, EventTicketType } from './event-ticket-type.interface';

/**
 * Single source of truth for whether a ticket type may be selected or added to
 * the cart. A ticket type is addable only when the parent event is OPEN, the
 * ticket-type status is OPEN, and there is remaining availability.
 */
export function isTicketAddable(
  ticket: Pick<EventTicketType, 'status' | 'availableTickets'> | null | undefined,
  eventStatus: string | undefined
): boolean {
  if (!ticket) {
    return false;
  }
  return (
    eventStatus === 'OPEN' &&
    ticket.status === EventTicketStatus.OPEN &&
    ticket.availableTickets > 0
  );
}
